<ng-template #confirmtemplate>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Confirm the deletion</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="closeConfirmRemoveDialog()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body text-center">
    <div class="text-start">Confirm the deletion? This operation can not be undone</div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn at-ct-btn-ib-white-with-dark-bg" (click)="closeConfirmRemoveDialog()">Cancel
    </button>
    <button type="button" class="btn btn-danger" (click)="confirmEntityDeletion()">Confirm the deletion</button>
  </div>
</ng-template>

<div class="row justify-content-center">
  <div class="btn-group" dropdown>
    <i class="fas fa-ellipsis-v fa-1x mouse-pointer text-secondary" dropdownToggle></i>
    <div  class="dropdown-menu dropdown-menu-right" *dropdownMenu>
      <button class="dropdown-item" type="button" (click)="editEntity()" >Update market</button>
      <button class="dropdown-item" type="button" (click)="confirmRemoveDialog(confirmtemplate)">Delete market</button>
    </div>
  </div>
</div>
